<template>
  <div :style="hostWrapperStyle">
    <DynamicComponentProduction
      v-if="embeddedDcId"
      :dynamic-component-id="embeddedDcId"
      :is-production="renderingInProduction"
      :entity-id="entity.storyId"
      :theme-mode="themeMode"
    />
  </div>
</template>

<script>
import { EpisodePageElementMixin } from "%/dynamic-component-editor/standard-pages/episode-page/episode-page-element-mixin";
import ReferencedComponentId from "%/dynamic-component-editor/options/referenced-component-id";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import DynamicComponentProduction
  from "%/dynamic-component-editor/components/DynamicComponentProductionComponent.vue";
import DcHostMixin from "%/dynamic-component-editor/mixins/dc-host-picker-mixin";

export default {
  name: "EpisodeCommentsWidget",
  components: { DynamicComponentProduction },
  mixins: [EpisodePageElementMixin, DcHostMixin],
  relatedComponents: ["Comments Widget"],
  elementPanelSettings: {
    displayName: "Comments Widget",
    displayIcon: "document",
    elementGroup: "episode",
    elementType: "element",
  },
  options: [
    ReferencedComponentId,
    ContextBindings,
    LayoutWidth,
  ],
  data() {
    return {
      defaultComponentName: "Comments Widget",
    };
  },
};
</script>
